export const URL_SMALL_LOGO = 'https://www.cliqueiachei.com.br/logotipo-logomarca/250/';

export const URL_CLIENT_PHOTOS = 'https://www.cliqueiachei.com.br/imagens-fotos-clientes-cliquei-achei/';

export const URL_DELIVERY_PHOTOS = 'https://www.cliqueiachei.com.br/fotos-cardapio/';

export const URL_DELIVERY_PHOTOS_THUMBS = 'https://www.cliqueiachei.com.br/fotos-cardapio/128/';
